import { groupBy, isEmpty, isEqual } from 'lodash';
import React, { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchFilials } from '../../action/handbook';
import Select from "react-select";
import _ from 'lodash';
import { selectStyles } from '../handbook/SelectStopList';

export const CHECKED = 1;
export const UNCHECKED = 2;
export const INDETERMINATE = -1;

const styles = {
  cursor: "pointer",
  display: "flex"
};

const IndeterminateCheckbox = (props) => {
  const { value, ...otherProps } = props;
  const checkRef = useRef();

  useEffect(() => {
    checkRef.current.checked = value === CHECKED;
    checkRef.current.indeterminate = value === INDETERMINATE;
  }, [value]);

  return (
    <input
      type="checkbox"
      ref={checkRef}
      {...otherProps}
      onChange={props.onChange}
      style={{ cursor: "pointer" }}
    />
  );
};

const Option = (props) => {
  const onClick = (e) => {
    e.preventDefault();
    e.stopPropagation();

    props.selectOption(props.data, "set-value");
  };
  return (
    <div
      style={{ display: "flex", ...props.getStyles("option", props) }}
      onClick={onClick}
    >
      <IndeterminateCheckbox
        value={props.isSelected ? CHECKED : UNCHECKED}
        key={props.isSelected}
      />
       {props.label}
    </div>
  );
};

const Group = (props) => {
  const { data, options, selectProps } = props;

  const selected = options.reduce(
    (prev, curr) => (prev += curr.isSelected ? 1 : 0),
    0
  );
  const value =
    selected === options.length
      ? CHECKED
      : selected === 0
      ? UNCHECKED
      : INDETERMINATE;

  const onChange = (e) => {
    e.preventDefault();
    e.stopPropagation();
    
    const mapped = options.map(({ data }) => data);
    
    if (value === CHECKED || value === INDETERMINATE) {
      const newVal = selectProps.value.filter(item => {
        if(_.some(mapped, item)) {
          return false
        }
        return true
      })

      selectProps.onChange([...newVal], {action: "set-value"});
    }

    if (value === UNCHECKED) {
      if(selectProps.value === null || selectProps.value === undefined) {
        selectProps.onChange([...mapped], {action: "set-value"});
      } else {
        selectProps.onChange([...selectProps.value, ...mapped], {action: "set-value"});
      }
    }

  };

  return (
    <div onClick={onChange}>
      <div style={styles}>
        <IndeterminateCheckbox value={value} key={value} />
        {data.label}
      </div>
      {!data.noRenderOptions && <div style={{ marginLeft: "15px" }}>{props.children}</div>}
    </div>
  );
};

const MoreSelectedBadge = ({ items, total }) => {
  const style = {
    marginLeft: "auto",
    background: "#d4eefa",
    borderRadius: "4px",
    fontFamily: "Open Sans",
    fontSize: "11px",
    padding: "3px",
    order: 99
  };

  if (items.length === total) {
    return <div style={style}>Все филиалы</div>;
  }

  const title = items.join(", ");
  const length = items.length;
  const label = `${length} ${length === 1 ? "филиал" : length < 5 ? "филиала" : "филиалов"}`;

  return (
    <div style={style} title={title}>
      {label}
    </div>
  );
};

const MultiValue = ({ index, getValue, selectProps }) => {
  const overflow = getValue()
      .slice(0)
      .map((x) => x.label);
  return index === 0 ? (
      <MoreSelectedBadge items={overflow} total={selectProps.totalOptionsCount} />
  ) : null;
};

export default function PointsSelect({ 
  width = 200, 
  placeholder, 
  values = [], 
  blur = false, 
  setData, 
  disabled = false, 
  notAll, 
  options 
}) {
  const dispatch = useDispatch();

  const points = useSelector(state => state.handbook.filials);
  const pointsCount = useSelector(state => state.handbook.count.filials);
  const pointLoading = useSelector(state => state.loaders.filials);
  const [ loading, setLoading ] = useState(false);
  const [ selected, setSelected ] = useState([]);

  useEffect(() => {
    setSelected(values);
  }, [values]);

  const handleChange = (options, instructions) => (e) => {
    setSelected(e);
    if (!blur) setData(e);
  };

  const onBlur = () => {
    if (blur && !isEqual(values, selected)) setData(selected);
  }

  useEffect(() => {
    const getData = async () => {
      setLoading(true);
      if (!pointLoading && (isEmpty(points) || points.length < pointsCount)) await dispatch(fetchFilials(null, true));
      setLoading(false);
    };
    if (!options) getData();
  }, [dispatch, points, pointsCount, pointLoading, options]);

  if (loading) return (
    <div style={{ width }}>
      <Select
        isLoading={true}
        placeholder={placeholder ? placeholder : 'Филиалы'}
      />
    </div>
  );

  const renderPointLabel = (point) => {
    if (!point) return '';
    const cityName = point && (point.city && point.city.name) ? point.city.name : null 
    return `${cityName + ', '}${point.street || 'Улица не указана'} ${point.house || ''}`
  };

  const pointOptions = () => {
    const arr = options ? options : points;
    const filials = arr.map((point) => ({
      value: point.id,
      label: renderPointLabel(point),
      city: point.city,
    })).sort((a, b) => {
      if (a.label < b.label) return -1;
      if (a.label > b.label) return 1;
      return 0;
    });

    const groupedPoints = groupBy(filials, (item) => (item && item.city && item.city.name) || "");
    const result = Object.entries(groupedPoints).flatMap(([city, items]) => {
      return {
        label: city,
        options: items.map((item) => ({ value: item.value, label: item.label }))
      }
    });

    if (notAll) return result;
    return [{ label: 'Выбрать все', options: filials.map((item) => ({ value: item.value, label: item.label })), noRenderOptions: true }, ...result];
  };

  const totalOptions = options ? options.length : points.length;

  return (
    <div style={{ width }}>
      <Select
        isDisabled={disabled}
        isMulti
        isSearchable
        menuPortalTarget={document.body}
        placeholder={placeholder ? placeholder : 'Филиалы'}
        closeMenuOnSelect={false}
        options={pointOptions()}
        noOptionsMessage={() => 'Нет филиалов'}
        value={selected}
        hideSelectedOptions={false}
        onChange={(e) => handleChange()(e)}
        onBlur={onBlur}
        components={{ 
          Option, 
          Group, 
          MultiValue
        }}
        totalOptionsCount={totalOptions}
        styles={{
          ...selectStyles,
          container: (provided) => ({
            ...provided,
            maxWidth: width,
          }),
        }}
      />
    </div>
  );
}